const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL
//--------------------------UTILS-------------------------------------------------

function isEmptyArray(arr) {
  if (Array.isArray(arr) && !arr.length) {
    return true
  }
  return false
}

function isEmptyObject(obj) {
  if (isEmptyArray(Object.keys(obj))) {
    return true
  }
  return false
}

function createCategoryParam(categories) {
  //console.log('createCategoryparams:', categories)
  return categories.map(category => {
    return `cat=${category.id}&`
  }).join('')
}

function createNewUrl(url, params) {
  let gUrl = new URL(url);
  if (!isEmptyObject(params)) {
    Object.keys(params).map(key => {
      if (Array.isArray(params[key])) {
        params[key].map(pkey => {
          gUrl.searchParams.append(key, pkey)
          return true
        })
      } else {
        gUrl.searchParams.append(key, params[key])
      }
      return true
    })
  }
  return gUrl.toString()
}

//--------------------------GET REQUEST-------------------------------------------------

async function getRequest({ url, params = {} }) {
  try {
    let response;
    url = createNewUrl(url, params)
    //console.log('GetRequest URL: ', url)

    response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
    })

    response = await response.json()
    //console.log('getRequest response:', response)

    return response
  } catch (error) {
    console.log('There was an error:', error)
    return error
  }
}

//--------------------------POST REQUEST-------------------------------------------------

async function postRequest(url, params = {}, payload) {
  let response;
  try {
    url = createNewUrl(url, params)
    //console.log('PostRequest URL: ', url)
    response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    response = await response.json()

  } catch (error) {
    console.log('There was an error:', error)
  }
  return response
}

//--------------------------PUT REQUEST-------------------------------------------------

async function putRequest(url, params = {}, payload) {
  let response;
  try {
    url = createNewUrl(url, params)
    //console.log('PutRequest URL: ', url)
    response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
    response = await response.json()

  } catch (error) {
    console.log('There was an error:', error)
  }
  return response
}

//--------------------------DELETE REQUEST-------------------------------------------------

async function deleteRequest(url, params = {}) {
  try {
    url = createNewUrl(url, params)
    console.log('DeleteRequest URL: ', url)
    let response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    });

    response = await response.json();
    console.log('deleteRequest response:', response);
    return response;
  } catch (error) {
    console.error('There was an error with the delete request:', error);
    throw error;
  }
}

//--------------------------REQUESTS-------------------------------------------------

export function getUser(userId) {
  let url = `${API_GATEWAY_URL}/v1/users/${userId}`
  let response = getRequest({ url })
  return response
}

export function updateUser(userId, userData) {
  let url = `${API_GATEWAY_URL}/k1/users/${userId}`
  return putRequest(url, {}, userData)
}

export function getRequestAssets(config) {
  const currentPage = config.currentPage.current;
  const limitSize = config.pageLimit;
  const userId = config.userId;
  const categories = createCategoryParam(config.categories) || ''

  let url = `${API_GATEWAY_URL}/v1/users/${userId}/assets?${categories}page=${currentPage}&limit=${limitSize}`
  let response = getRequest({ url })
  config.currentPage.current += 1;
  return response
}

export function fetchDuplicates() {
  let url = `${API_GATEWAY_URL}/v1/categories/system/duplicate`
  let response = getRequest({ url })
  return response
}
export function fetchFavorites() {
  let url = `${API_GATEWAY_URL}/v1/categories/system/favorite`
  let response = getRequest({ url })
  return response
}
export async function fetchAssetsByCategory({ categoryId, userId }) {
  let url = `${API_GATEWAY_URL}/v1/users/${userId}/assets?cat=${categoryId}`;
  try {
    let response = await getRequest({ url });
    // console.log('fetchAssetsByCategory:', response)
    return response;
  } catch (error) {
    console.error(`Error fetching assets for category ${categoryId}:`, error);
    throw error;
  }
}

export async function fetchUncategorizedAssets({ userId }) {
  let url = `${API_GATEWAY_URL}/v1/users/${userId}/assets?cat=none`;
  console.log('Request URL:', url);
  try {
    let response = await getRequest({ url });
    if (response && response.assets) {
      console.log('Uncategorized assets:', response.assets);
    }
    return response;
  } catch (error) {
    console.error('Error fetching uncategorized assets:', error);
    throw error;
  }
}

export function postFavorites(config) {
  let url = `${API_GATEWAY_URL}/v1/users/${config?.userId}/categorizeassets`
  let payload = config.payload
  return postRequest(url, {}, payload)
}

export function deleteAsset(config) {
  let url = `${API_GATEWAY_URL}/v1/users/${config?.userId}/assets/${config?.assetId}`
  let payload = config.payload
  return deleteRequest(url, {}, payload)
}

//userId, keysForSigning
export function postRequestSignedUrls(config) {
  let url = `${API_GATEWAY_URL}/k1/users/${config?.userId}/signurls`
  let payload = config?.payload
  //console.log(config?.log)
  return postRequest(url, {}, payload)
}

export function postRequestCustomerPortalSession(config) {
  let url = `${API_GATEWAY_URL}/k1/subscription/billing/session`
  let payload = config?.payload
  //console.log(config?.log)
  return postRequest(url, {}, payload)
}

export function getRequestUserCategories(config) {
  let userId = config.userId || "00000000-0000-0000-0000-000000000000"
  let url = `${API_GATEWAY_URL}/v1/users/${userId}/topcategories`
  // console.log(config?.log)
  return getRequest({ url })
}

export function getRequestAssetsByQuery(config) {
  let userId = config?.userId || "00000000-0000-0000-0000-000000000000"
  let url = `${API_GATEWAY_URL}/v1/users/${userId}/assets`
  let params = config?.params;

  //console.log('params:',config)
  return getRequest({ url, params: params })
}
